/**
 * Default page size and offset used for paginated list requests.
 */
export const REQUEST_DEFAULT_LIMIT = 100
export const REQUEST_DEFAULT_OFFSET = 0
